'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesAccessibilityTab: {
            type: String,
            default: undefined,
            kComposite: 'messages.accessibilityTab'
        },
        messagesAddColumnLeft: {
            type: String,
            default: undefined,
            kComposite: 'messages.addColumnLeft'
        },
        messagesAddColumnRight: {
            type: String,
            default: undefined,
            kComposite: 'messages.addColumnRight'
        },
        messagesAddRowAbove: {
            type: String,
            default: undefined,
            kComposite: 'messages.addRowAbove'
        },
        messagesAddRowBelow: {
            type: String,
            default: undefined,
            kComposite: 'messages.addRowBelow'
        },
        messagesAlignCenter: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignCenter'
        },
        messagesAlignCenterBottom: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignCenterBottom'
        },
        messagesAlignCenterMiddle: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignCenterMiddle'
        },
        messagesAlignCenterTop: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignCenterTop'
        },
        messagesAlignLeft: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignLeft'
        },
        messagesAlignLeftBottom: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignLeftBottom'
        },
        messagesAlignLeftMiddle: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignLeftMiddle'
        },
        messagesAlignLeftTop: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignLeftTop'
        },
        messagesAlignRemove: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignRemove'
        },
        messagesAlignRight: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignRight'
        },
        messagesAlignRightBottom: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignRightBottom'
        },
        messagesAlignRightMiddle: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignRightMiddle'
        },
        messagesAlignRightTop: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignRightTop'
        },
        messagesAlignment: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignment'
        },
        messagesAssociateCellsWithHeaders: {
            type: String,
            default: undefined,
            kComposite: 'messages.associateCellsWithHeaders'
        },
        messagesBackColor: {
            type: String,
            default: undefined,
            kComposite: 'messages.backColor'
        },
        messagesBackground: {
            type: String,
            default: undefined,
            kComposite: 'messages.background'
        },
        messagesBold: {
            type: String,
            default: undefined,
            kComposite: 'messages.bold'
        },
        messagesBorder: {
            type: String,
            default: undefined,
            kComposite: 'messages.border'
        },
        messagesStyle: {
            type: String,
            default: undefined,
            kComposite: 'messages.style'
        },
        messagesCaption: {
            type: String,
            default: undefined,
            kComposite: 'messages.caption'
        },
        messagesCellMargin: {
            type: String,
            default: undefined,
            kComposite: 'messages.cellMargin'
        },
        messagesCellPadding: {
            type: String,
            default: undefined,
            kComposite: 'messages.cellPadding'
        },
        messagesCellSpacing: {
            type: String,
            default: undefined,
            kComposite: 'messages.cellSpacing'
        },
        messagesCellTab: {
            type: String,
            default: undefined,
            kComposite: 'messages.cellTab'
        },
        messagesCleanFormatting: {
            type: String,
            default: undefined,
            kComposite: 'messages.cleanFormatting'
        },
        messagesCollapseBorders: {
            type: String,
            default: undefined,
            kComposite: 'messages.collapseBorders'
        },
        messagesColumns: {
            type: String,
            default: undefined,
            kComposite: 'messages.columns'
        },
        messagesCreateLink: {
            type: String,
            default: undefined,
            kComposite: 'messages.createLink'
        },
        messagesCreateTable: {
            type: String,
            default: undefined,
            kComposite: 'messages.createTable'
        },
        messagesCreateTableHint: {
            type: String,
            default: undefined,
            kComposite: 'messages.createTableHint'
        },
        messagesCssClass: {
            type: String,
            default: undefined,
            kComposite: 'messages.cssClass'
        },
        messagesDeleteColumn: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteColumn'
        },
        messagesDeleteRow: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteRow'
        },
        messagesDialogCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.dialogCancel'
        },
        messagesDialogInsert: {
            type: String,
            default: undefined,
            kComposite: 'messages.dialogInsert'
        },
        messagesDialogOk: {
            type: String,
            default: undefined,
            kComposite: 'messages.dialogOk'
        },
        messagesDialogUpdate: {
            type: String,
            default: undefined,
            kComposite: 'messages.dialogUpdate'
        },
        messagesEditAreaTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editAreaTitle'
        },
        messagesFileTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.fileTitle'
        },
        messagesFileWebAddress: {
            type: String,
            default: undefined,
            kComposite: 'messages.fileWebAddress'
        },
        messagesFontName: {
            type: String,
            default: undefined,
            kComposite: 'messages.fontName'
        },
        messagesFontNameInherit: {
            type: String,
            default: undefined,
            kComposite: 'messages.fontNameInherit'
        },
        messagesFontSize: {
            type: String,
            default: undefined,
            kComposite: 'messages.fontSize'
        },
        messagesFontSizeInherit: {
            type: String,
            default: undefined,
            kComposite: 'messages.fontSizeInherit'
        },
        messagesForeColor: {
            type: String,
            default: undefined,
            kComposite: 'messages.foreColor'
        },
        messagesFormatBlock: {
            type: String,
            default: undefined,
            kComposite: 'messages.formatBlock'
        },
        messagesFormatting: {
            type: String,
            default: undefined,
            kComposite: 'messages.formatting'
        },
        messagesHeight: {
            type: String,
            default: undefined,
            kComposite: 'messages.height'
        },
        messagesId: {
            type: String,
            default: undefined,
            kComposite: 'messages.id'
        },
        messagesImageAltText: {
            type: String,
            default: undefined,
            kComposite: 'messages.imageAltText'
        },
        messagesImageHeight: {
            type: String,
            default: undefined,
            kComposite: 'messages.imageHeight'
        },
        messagesImageWebAddress: {
            type: String,
            default: undefined,
            kComposite: 'messages.imageWebAddress'
        },
        messagesImageWidth: {
            type: String,
            default: undefined,
            kComposite: 'messages.imageWidth'
        },
        messagesIndent: {
            type: String,
            default: undefined,
            kComposite: 'messages.indent'
        },
        messagesInsertFile: {
            type: String,
            default: undefined,
            kComposite: 'messages.insertFile'
        },
        messagesInsertHtml: {
            type: String,
            default: undefined,
            kComposite: 'messages.insertHtml'
        },
        messagesInsertImage: {
            type: String,
            default: undefined,
            kComposite: 'messages.insertImage'
        },
        messagesInsertOrderedList: {
            type: String,
            default: undefined,
            kComposite: 'messages.insertOrderedList'
        },
        messagesInsertUnorderedList: {
            type: String,
            default: undefined,
            kComposite: 'messages.insertUnorderedList'
        },
        messagesItalic: {
            type: String,
            default: undefined,
            kComposite: 'messages.italic'
        },
        messagesOverflowAnchor: {
            type: String,
            default: undefined,
            kComposite: 'messages.overflowAnchor'
        },
        messagesJustifyCenter: {
            type: String,
            default: undefined,
            kComposite: 'messages.justifyCenter'
        },
        messagesJustifyFull: {
            type: String,
            default: undefined,
            kComposite: 'messages.justifyFull'
        },
        messagesJustifyLeft: {
            type: String,
            default: undefined,
            kComposite: 'messages.justifyLeft'
        },
        messagesJustifyRight: {
            type: String,
            default: undefined,
            kComposite: 'messages.justifyRight'
        },
        messagesLinkOpenInNewWindow: {
            type: String,
            default: undefined,
            kComposite: 'messages.linkOpenInNewWindow'
        },
        messagesLinkText: {
            type: String,
            default: undefined,
            kComposite: 'messages.linkText'
        },
        messagesLinkToolTip: {
            type: String,
            default: undefined,
            kComposite: 'messages.linkToolTip'
        },
        messagesLinkWebAddress: {
            type: String,
            default: undefined,
            kComposite: 'messages.linkWebAddress'
        },
        messagesOutdent: {
            type: String,
            default: undefined,
            kComposite: 'messages.outdent'
        },
        messagesPrint: {
            type: String,
            default: undefined,
            kComposite: 'messages.print'
        },
        messagesRows: {
            type: String,
            default: undefined,
            kComposite: 'messages.rows'
        },
        messagesSelectAllCells: {
            type: String,
            default: undefined,
            kComposite: 'messages.selectAllCells'
        },
        messagesStrikethrough: {
            type: String,
            default: undefined,
            kComposite: 'messages.strikethrough'
        },
        messagesSubscript: {
            type: String,
            default: undefined,
            kComposite: 'messages.subscript'
        },
        messagesSummary: {
            type: String,
            default: undefined,
            kComposite: 'messages.summary'
        },
        messagesSuperscript: {
            type: String,
            default: undefined,
            kComposite: 'messages.superscript'
        },
        messagesTableTab: {
            type: String,
            default: undefined,
            kComposite: 'messages.tableTab'
        },
        messagesTableWizard: {
            type: String,
            default: undefined,
            kComposite: 'messages.tableWizard'
        },
        messagesUnderline: {
            type: String,
            default: undefined,
            kComposite: 'messages.underline'
        },
        messagesUnits: {
            type: String,
            default: undefined,
            kComposite: 'messages.units'
        },
        messagesUnlink: {
            type: String,
            default: undefined,
            kComposite: 'messages.unlink'
        },
        messagesViewHtml: {
            type: String,
            default: undefined,
            kComposite: 'messages.viewHtml'
        },
        messagesWidth: {
            type: String,
            default: undefined,
            kComposite: 'messages.width'
        },
        messagesWrapText: {
            type: String,
            default: undefined,
            kComposite: 'messages.wrapText'
        }
    }
};